<template>
    <div class="akpk-card">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <!-- <h3 class="mb-0">AKPK</h3> -->
                 <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                           AKPK
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_akpk_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
            </b-card-header>
            <div v-if="tableData.length > 0" class="rounded-bottom">
                <el-table
                :data="tableData"
                style="width: 100%">
                    <el-table-column
                        prop="akpk_approved_date"
                        label="Date"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.akpk_approved_date }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="akpk_loan_statue"
                        label="Facility"
                        min-width="150"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.akpk_loan_statue }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="akpk_current_outstanding"
                        label="Outstanding Balance (RM)"
                        min-width="250"
                        width="auto">
                        <template slot-scope="scope">
                            <p class="top-line">{{ scope.row.akpk_current_outstanding | moneyFormatter }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="bg-light p-3 text-center rounded-bottom">
                <p class="text-xs">No AKPK recorded</p>
            </div>
        </b-card>
         <AkpkCardModal
            :akpk-card="akpkCard" 
            :akpk-sub-items="akpkSubItems"
            :show_akpk_full_view.sync="modals.show_akpk_full_view"
        />
    </div>
</template>
<script>
    import { Card, Button, Table, TableColumn } from 'element-ui'
    import { axios, getHeader } from '@/assets/js/httpImports.js'
    import AkpkCardModal from '@/views/CustomerProfile/CustomerModals/AkpkCardModal.vue'

    export default {
        name: 'akpk-card',
        props: ['akpk-card', 'akpk-sub-items'],
        components: {
            AkpkCardModal,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                tableData: this.akpkCard,
                  modals: {
                  show_akpk_full_view: false
                }
            }
        },
    }
</script>